import PropTypes from 'prop-types'

export const PropTypeS3Object = PropTypes.shape({
  key: PropTypes.string.isRequired,
  bucket: PropTypes.string.isRequired,
  region: PropTypes.string.isRequired,
})
